class NavNotesModalController {
    constructor($window, $log, $uibModal, moment, TraceHubExService, TestNotesServiceApi, RouteService, UserDetailsApi, UserAdminService, SettingsService) {
        this.init = () => {
            this.renderTestNotes();
            this.UserDetailsApi.get().then((response) => {
                this.connectedUser = response.data;
            });
        };
        this.$onInit = () => {
            this.init();
            this.SettingsService.getSettings().then((response) => {
                const appSettings = response.data;
                this.TraceHubExService.connectWithSpecificTransport('NavNotesModalController', appSettings.SignalRTransport);
                this.TraceHubExService.on('NavNotesModalController', 'onTestNote', () => {
                    this.renderTestNotes();
                });
            });
        };
        this.getFromNowString = (utcTime) => {
            return this.moment
                .utc(utcTime)
                .local()
                .fromNow();
        };
        this.renderTestNotes = () => {
            this.TestNotesServiceApi.unreadTestNotes().then((response) => {
                let sysMessages = response.data;
                this.notes = sysMessages;
                if (this.notes.length === 0) {
                    this.close();
                }
            });
        };
        this.close = () => {
            this.dismiss();
        };
        this.viewTraceDetails = (traceId) => {
            if (traceId == null) {
                return;
            }
            this.TestNotesServiceApi.testDetails(traceId).then((response) => {
                // TODO: Rationalise this
                let items = response.data;
                let selectedItems = {
                    selectedTester: items.Tester,
                    selectedSim: items.Sim,
                    selectedSuite: items.Suite,
                    selectedTest: items.Test,
                    projectIterationId: items.ProjectIterationId,
                    selectedTraceId: 0 // We need this as we want all of the traces for the test
                };
                // openDetails(vm.userDetails, selectedItems);
                let mode = { view: true, run: true };
                let tdParams = {
                    selectedItems: selectedItems,
                    mode: mode,
                    user: this.connectedUser,
                    projectTestingView: true,
                    overTheShoulder: true
                };
                let modalInstance = this.uibModal.open({
                    animation: true,
                    size: 'xl',
                    backdrop: 'static',
                    component: 'traceDetailsModal',
                    resolve: {
                        params: () => {
                            return tdParams;
                        }
                    }
                });
            });
        };
        this.resolveNote = (sysMsgId) => {
            this.TestNotesServiceApi.resolve(sysMsgId).then((data) => {
                this.renderTestNotes();
            });
        };
        this.supportTester = (note) => {
            let dest = 'Home/' + note.UserId;
            this.UserAdminService.singleUser(note.UserId).then(response => {
                const user = response.data;
                if (user.IsGroupTester) {
                    dest = 'GtHome/' + note.UserId;
                }
                return this.RouteService.buildRoute(dest);
            }).then((route) => this.window.location.href = route);
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop('NavNotesModalController');
        };
        this.window = $window;
        this.log = $log;
        this.uibModal = $uibModal;
        this.moment = moment;
        this.TraceHubExService = TraceHubExService;
        this.TestNotesServiceApi = TestNotesServiceApi;
        this.RouteService = RouteService;
        this.UserDetailsApi = UserDetailsApi;
        this.UserAdminService = UserAdminService;
        this.SettingsService = SettingsService;
    }
}
angular.module('app').component('navNotesModal', {
    bindings: {
        resolve: '<', // nothing required
        close: '&',
        dismiss: '&'
    },
    controllerAs: 'vm',
    controller: NavNotesModalController,
    templateUrl: 'scripts/app/partials/TestNotes/nav-notes-modal.tpl.html'
});
